// Vuex module to manage Event creation/update validation & readiness
import { isResourcesValid } from '@/utils/resourcesValidation'

export default {
    namespaced: true,
    state: () => ({
        hasDetailsErrors: false,
        hasResourceErrors: false,
        hasPriceErrors: false,
        hasPriceGroupErrors: false
    }),
    mutations: {
        SET_HAS_DETAILS_ERRORS(state, hasError) {
            state.hasDetailsErrors = !!hasError;
        },
        SET_HAS_RESOURCE_ERRORS(state, hasError) {
            state.hasResourceErrors = !!hasError;
        },
        SET_HAS_PRICE_ERRORS(state, hasError) {
            state.hasPriceErrors = !!hasError;
        },
        SET_HAS_PRICE_GROUP_ERRORS(state, hasError) {
            state.hasPriceGroupErrors = !!hasError;
        }
    },
    actions: {
        setHasDetailsErrors({ commit }, hasError) {
            commit('SET_HAS_DETAILS_ERRORS', hasError);
        },
        setHasResourceErrors({ commit }, hasError) {
            commit('SET_HAS_RESOURCE_ERRORS', hasError);
        },
        setHasPriceErrors({ commit }, hasError) {
            commit('SET_HAS_PRICE_ERRORS', hasError);
        },
        setHasPriceGroupErrors({ commit }, hasError) {
            commit('SET_HAS_PRICE_GROUP_ERRORS', hasError);
        }
    },
    getters: {
        hasDetailsErrors: state => state.hasDetailsErrors,
        hasResourceErrors: state => state.hasResourceErrors,
        hasPriceErrors: state => state.hasPriceErrors,
        hasPriceGroupErrors: state => state.hasPriceGroupErrors,

        // Keep logic utility getter for early resource validity checks
        isResourcesValid: (state, getters, rootState, rootGetters) => {
            const event = rootGetters.getSelectedEvent;
            return isResourcesValid(event);
        },
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/eventFormState.js